// Shared homepage facts keep the server response and client-rendered page aligned.
const content = require('../content/landingPage.json');

function getLandingFaqs(freeCredits) {
  return content.faqs.map(faq => ({
    ...faq,
    answer: faq.answer.replace('{{FREE_CREDITS}}', String(freeCredits)),
  }));
}

const landingPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  '@id': 'https://gab.ai/#webpage',
  url: 'https://gab.ai/',
  name: content.title,
  description: content.description,
  inLanguage: 'en',
  isPartOf: { '@id': 'https://gab.ai#website' },
  publisher: { '@id': 'https://gab.ai#organization' },
  mainEntity: { '@id': 'https://gab.ai/#software' },
};

module.exports = { content, getLandingFaqs, landingPageStructuredData };
